module.exports = __webpack_public_path__ + "img/logo.4604b1e6.png";